import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./News.scss";
import PageBanner from "../layouts/PageBanner";
import aboutHero from "../../assets/about-hero.jpg";

const API = "https://api.ainfotech.com.np";

function NewsCard({ item }) {
  const img = item.cover_image ? `${API}${item.cover_image}` : item.image;
  const date = item.published_at
    ? new Date(item.published_at).toLocaleDateString()
    : item.date;

  return (
    <article className="avena-blogCard">
      <div className="avena-blogCard__media">
        <Link to={`/news/${item.slug}`} className="stretched-link">
          {img ? <img src={img} alt={item.title} /> : <div className="thumb-empty">No image</div>}
        </Link>
      </div>

      <div className="avena-blogCard__body">
        <div className="avena-blogCard__meta">
          {date && <span className="dot-sep">{date}</span>}
        </div>
        <h3 className="avena-blogCard__title">
          <Link to={`/news/${item.slug}`}>{item.title}</Link>
        </h3>
        <p className="avena-blogCard__excerpt">{item.excerpt}</p>
        <div className="avena-blogCard__underline" />
      </div>
    </article>
  );
}

export default function News() {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const limit = 12;
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        setErr(""); setLoading(true);
        const res = await fetch(`${API}/api/eventmedia?status=published&page=${page}&limit=${limit}`);
        const data = await res.json();
        if (!res.ok) throw new Error(data?.error || "Failed to load");
        setItems(data.items || []);
      } catch (e) {
        setErr(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [page]);

  return (
    <div className="avena-news">
      <PageBanner
        title="News & Events"
        bg={aboutHero}
        crumbs={[{ label: "Home", href: "/" }, { label: "News & Events" }]}
      />

      <section className="container py-5">
        {err && <div className="alert alert-danger">{err}</div>}
        {loading && <div className="text-muted mb-3">Loading…</div>}

        <div className="row g-5">
          {items.map((p) => (
            <div key={p.id} className="col-12 col-lg-6">
              <NewsCard item={p} />
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-center gap-2 mt-4">
          <button className="btn btn-outline-secondary" onClick={() => setPage((x) => Math.max(1, x - 1))}>
            Prev
          </button>
          <span className="align-self-center">Page {page}</span>
          <button className="btn btn-outline-secondary" onClick={() => setPage((x) => x + 1)}>
            Next
          </button>
        </div>
      </section>
    </div>
  );
}
